import { render } from "./SettingsBlockV2.vue?vue&type=template&id=5a1c1466&scoped=true&ts=true"
import script from "./SettingsBlockV2.vue?vue&type=script&lang=ts"
export * from "./SettingsBlockV2.vue?vue&type=script&lang=ts"

import "./SettingsBlockV2.vue?vue&type=style&index=0&id=5a1c1466&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1c1466"]])

export default __exports__